
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...slugs]",
      function () {
        return require("private-next-pages/c/[...slugs]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[...slugs]"])
      });
    }
  